import * as React from "react";

const SvgIcnClock = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            d="M12 3a9 9 0 110 18 9 9 0 010-18zm0 1a8 8 0 100 16 8 8 0 000-16zm0 3a.5.5 0 01.492.41l.008.09v4.293l3.354 3.353a.5.5 0 01-.638.765l-.07-.057-3.5-3.5-.011-.013a.503.503 0 01-.033-.039l.044.052a.502.502 0 01-.138-.264l-.003-.016a.503.503 0 01-.005-.062V7.5A.5.5 0 0112 7z"
        />
    </svg>
);

export default SvgIcnClock;
